// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__+EOJC","message":"Messages_message__t8dAg","text":"Messages_text__pn3ii","user":"Messages_user__KVsVw","me":"Messages_me__1VPNw"};